import { FC, PropsWithChildren } from "react";
import styles from "./Inline.module.css";

type InlineProps = PropsWithChildren & {
  title?: string;
  onClick?: () => void;
};

const Inline: FC<InlineProps> = ({ title, onClick, children }) => (
  <div title={title} onClick={onClick} className={styles.inline}>
    {children}
  </div>
);

export default Inline;
